import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom email validation pattern.
 * Matches standard email format with support for:
 * - RFC 5321 special characters in local part: .!#$%&'*+/=?^_`{|}~
 * - French and German special characters (àâäæçéèêëïîôöùûüÿœßÄÖÜ etc.)
 * - Multiple subdomains (e.g., mail.example.co.uk)
 * - TLD with 2 or more letters
 */
export const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~àâäæçéèêëïîôöùûüÿœÀÂÄÆÇÉÈÊËÏÎÔÖÙÛÜŸŒßÄÖÜäöü-]+@[a-zA-Z0-9àâäæçéèêëïîôöùûüÿœÀÂÄÆÇÉÈÊËÏÎÔÖÙÛÜŸŒßÄÖÜäöü-]+(\.[a-zA-Z0-9àâäæçéèêëïîôöùûüÿœÀÂÄÆÇÉÈÊËÏÎÔÖÙÛÜŸŒßÄÖÜäöü-]+)*\.[a-zA-Z]{2,}$/;

/**
 * Custom email validator for reactive forms.
 * Uses a stricter pattern than Angular's built-in Validators.email.
 *
 * Usage:
 * ```typescript
 * email: ['', [Validators.required, emailValidator()]]
 * ```
 */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values (use Validators.required for that)
    }

    const valid = EMAIL_PATTERN.test(control.value);
    return valid ? null : { email: true };
  };
}
